package com.parmartechnologies.commerce.feature.order.viewModel

import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.cart.model.CartItem
import com.parmartechnologies.core.feature.order.model.Order
import com.parmartechnologies.core.feature.order.network.CreateOrderRequest
import com.parmartechnologies.core.feature.order.network.CreateOrderResponse
import com.parmartechnologies.core.feature.order.network.RetrieveOrderRequest
import com.parmartechnologies.core.feature.order.network.UpdateOrderRequest
import com.parmartechnologies.core.feature.order.network.UpdateOrderResponse
import com.parmartechnologies.core.feature.order.reason.OrderReason
import com.parmartechnologies.core.feature.order.status.OrderStatus
import com.parmartechnologies.core.feature.product.model.ProductPrice
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.commerce.feature.order.handler.OrderHandler
import com.parmartechnologies.commerce.feature.order.network.OrderNetwork
import com.parmartechnologies.commerce.feature.order.repository.OrderRepository
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.core.navigation.NavigationParam
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime

class OrderViewModel(val business: Business) : AppViewModel() {
    val repository: OrderRepository = OrderHandler.shared().repository
    val allOrders = repository.allOrder

    fun loadOrders(param: NavigationParam?) {
        val request = RetrieveOrderRequest(
            AuthHandler.shared().UserID,
            param?.business!!._id,
            "",
            param.selectedBusiness._id
        )
        retrieve(request)
    }

    fun loadOrdersByUserId() {
        val request = RetrieveOrderRequest(
            AuthHandler.shared().UserID
        )
        retrieve(request)
    }

    fun retrieve(request: RetrieveOrderRequest) {
        startLoading()
        OrderNetwork.shared().retrieve(request) { response ->
            stopLoading()
            if (response?.payload?.isNotEmpty() == true) {
                scope.launch {
                    repository.allMutableOrder.emit(response.payload!!)
                }
            }
        }
    }

    fun reorder(order: Order){
        // check items quantity availability with current price
        // check address availability
        // prepare order request based on the order
        // place the order
    }

    @OptIn(ExperimentalTime::class)
    fun create(
        param: NavigationParam?,
        cartViewModel: CartViewModel,
        items: List<CartItem>,
        callBack: (Boolean?, Order?) -> Unit
    ) {
        val pricing = ProductPrice()
        pricing.FinalPrice = cartViewModel.totalAmount.value
        pricing.MRP = cartViewModel.mrp.value
        pricing.Price = cartViewModel.price.value
        pricing.Discount = cartViewModel.discount.value
        pricing.SalePrice = cartViewModel.subtotal.value
        pricing.Tax = cartViewModel.tax.value
        val request = CreateOrderRequest(
            timeStamp,
            UserID = AuthHandler.shared().UserID,
            BusinessID = param?.business!!._id,
            "",
            selectedBusinessID = param.selectedBusiness._id,
            address = param.address,
            AuthHandler.shared().deviceId,
            orderItems = items as ArrayList<CartItem>,
            pricing,
            deliveryType = if (param.address._id.isEmpty()) "TAKE_AWAY" else "DELIVERY"
        )
        create(request) { response->
            if (response?.payload?._id.isNullOrEmpty()) {
                callBack(false, null)
            } else {
                callBack(true, response.payload)
            }
        }
    }


    fun create(request: CreateOrderRequest, callBack: (CreateOrderResponse?) -> Unit){
        startLoading()
        OrderNetwork.shared().create(request) { response ->
            stopLoading()
            callBack(response)
        }
    }

    @OptIn(ExperimentalTime::class)
    fun retrieve() {
        val user = FriendlyUser()
        val request = RetrieveOrderRequest(UserID = user._id)
        OrderNetwork.shared().retrieve(request) { responseJson ->
            try {
                val payload = responseJson?.payload
                scope.launch {
                    repository.allMutableOrder.emit(payload ?: listOf())
                }
            } catch (e: Exception) {
                e.printStackTrace()
            }
        }
    }

    /**
     * Prepare order request for update and initiate the update call
     **/
    fun updateStatus(order: Order, status: OrderStatus, callBack: (Boolean) -> Unit){
        val request = UpdateOrderRequest(
            _id = order._id,
            AuthHandler.shared().UserID,
            selectedBusinessID = order.selectedBusinessID,
            status = status,
            reason = order.reason,
            reasonDescription = order.reasonDescription
        )
        update(request) { response->
            if (response?.payload?._id.isNullOrEmpty()) {
                callBack(false)
            } else {
                callBack(true)
            }
        }
    }

    /**
     * Prepare order request for update with reason and initiate the update call
     **/
    fun updateStatus(order: Order, status: OrderStatus, reason: OrderReason, description: String, callBack: (Boolean) -> Unit){
        val request = UpdateOrderRequest(
            _id = order._id,
            AuthHandler.shared().UserID,
            selectedBusinessID = order.selectedBusinessID,
            status = status,
            reason = reason,
            reasonDescription = description
        )
        update(request) { response->
            if (response?.payload?._id.isNullOrEmpty()) {
                callBack(false)
            } else {
                callBack(true)
            }
        }
    }

    /**
     * API Call initiated to update the order
     **/
    fun update(request: UpdateOrderRequest, callBack: (UpdateOrderResponse?) -> Unit){
        startLoading()
        OrderNetwork.shared().update(request) { response ->
            stopLoading()
            callBack(response)
        }
    }


//
//    fun insert(order: Order) {
//        CoroutineScope(Job() + Dispatchers.IO).launch {
//            DatabaseHandler.shared().database.orderDao()
//                .insert(order)
//        }
//    }

}